module.exports = __webpack_public_path__ + "img/open_dev_tools_chrome.4d63c593.png";